import { Box } from '@factorialco/deprecated-design-system'

import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'

import DetailLine from '../_DetailLine'

interface Props {
  incidenceDetailModel: IncidenceDetail
}

const ManualIncidenceInfo = ({ incidenceDetailModel }: Props) => {
  return (
    <Box gap="s16">
      {incidenceDetailModel.has('subject') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.subject')}
          value={incidenceDetailModel.attributes.subject}
        />
      )}
      {incidenceDetailModel.has('description') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.description')}
          value={incidenceDetailModel.attributes.description}
        />
      )}
      {incidenceDetailModel.has('effective_on') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.effective_on')}
          value={dateBackendToUI(incidenceDetailModel.attributes.effective_on)}
        />
      )}
      {incidenceDetailModel.has('created_at') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.reporting_date')}
          value={dateBackendToUI(incidenceDetailModel.attributes.created_at)}
        />
      )}
      {incidenceDetailModel.has('reported_by') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.reported_by')}
          value={
            incidenceDetailModel.attributes.reported_by ||
            i18n.t('bookkeepers.incidence.message.deleted_user')
          }
        />
      )}
    </Box>
  )
}

export default ManualIncidenceInfo
